import {cloneForm} from './form-helpers';

//groups library templates into the category headings rendered by the template picker
//and the get-started screen. category is free text set when the template is authored
export function groupTemplatesByCategory(templates) {
  const order = [];
  const byCategory = {};

  (templates || []).forEach(template => {
    const category = template.category || 'Templates';

    if (!byCategory[category]) {
      byCategory[category] = [];
      order.push(category);
    }

    byCategory[category].push(template);
  });

  return order.map(category => ({category, templates: byCategory[category]}));
}

//turns a library template into a new unsaved form for the builder. cloneForm regenerates
//ids and remaps every json logic reference so the new form is independent of the template
//it came from. alert contacts point at the current user since the library response carries
//none of its own
export function convertLibraryTemplate(template, currentUser) {
  const newForm = cloneForm(template.name, template);

  //the library identity belongs to the template and not the copy. carrying these over would
  //reuse the template's id, and make an ordinary customer's save look like an attempt to
  //author a library template which only agyle can do
  const {id, description, category, library, templateCode, ...form} = newForm;

  return {
    ...form,
    alerts: form.alerts.map(alert => ({
      ...alert,
      alertContacts: [currentUser]
    }))
  };
}
